var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasswordBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "f3ih6vcota",
    d: "M6 10.8V8.4c0-3.314 2.686-6 6-6s6 2.686 6 6v2.4c1.325 0 2.4 1.075 2.4 2.4v6c0 1.325-1.075 2.4-2.4 2.4H6c-1.325 0-2.4-1.075-2.4-2.4v-6c0-1.325 1.075-2.4 2.4-2.4zm9.6-2.4v2.4H8.4V8.4c0-1.988 1.612-3.6 3.6-3.6s3.6 1.612 3.6 3.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#37c0ca",
    xlinkHref: "#f3ih6vcota"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordBlue);
export default __webpack_public_path__ + "static/media/icon-password-blue.8891cc4a11cf5992d4135a9ad5e39c80.svg";
export { ForwardRef as ReactComponent };